import React, { useEffect } from "react";
import styles from "./MisProductos.module.scss";
import { connect } from "react-redux";
import {
    getPortfolio,
} from "../../../../store/actions/index";
import { motion } from "framer-motion";
import { ReactComponent as AddProyect } from "../../../../assets/svg/crearPP.svg";
import { ReactComponent as Search } from "../../../../assets/svg/misProyectosLittle.svg";
import EmptyState from "../../../UI/EmptyState/EmptyState";
import NuevoProducto from "./NuevoProducto/NuevoProducto.tsx";
import PortfolioCardWithLogic from "./PortfolioCardWithLogic.tsx";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";


const MisProductos = ({
    portfolios,
    portfoliosLoading,
    perfilAjeno,
    getPortfolio,
    myPerson,
    userData,
    createNewPortfolio,
    handleNewPortfolioClick,
    setInfoReady,
    ...props
}) => {

    useEffect(() => {
        getPortfolio(perfilAjeno);
      }, [perfilAjeno, getPortfolio]);

      useEffect(() => {
        if (!portfoliosLoading && portfolios !== undefined) {
          setInfoReady(true);
        }
      }, [portfoliosLoading, portfolios, setInfoReady]);


    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}
        >
            {createNewPortfolio && (
                <NuevoProducto cancel={() => handleNewPortfolioClick(false)} />
            )}
            {portfoliosLoading ? (
                <div className={styles.loadingContainer}>
                    <RegisteredUserProfileLoader />
                </div>
            ) : (
                portfolios && portfolios.length > 0 ? (
                    <div className={styles.container_body}>
                        {portfolios.map((portfolio) => (
                            <PortfolioCardWithLogic
                                key={portfolio.id}
                                portfolio={portfolio}
                                myPerson={myPerson}
                                userData={userData}
                                currentTab={props.currentTab}
                            />
                        ))}
                    </div>
                ) : (
                    myPerson ? (
                        <div className={styles.emptyState} onClick={handleNewPortfolioClick} >
                    <EmptyState title="No tienes productos o servicios publicados ¡Crea el primero!" icon={<AddProyect width={50} height={50}/> } />
                    </div>
                    ) : (       
                        <EmptyState title="Este usuario no tiene proyectos publicados" icon={<Search width={50} height={50} />} />
                    )             
                )
            )}
        </motion.section>
    );
};

const mapStateToProps = (state) => {
    return {
        portfolios: state.register.portfolios,
        portfoliosLoading: state.register.portfoliosLoading,
    };
};

export default connect(mapStateToProps, {
    getPortfolio,
})(MisProductos);